import React, { Component } from 'react';
import { Row, Col, Modal, Button } from 'antd';

function getFileExtension(fileName) {
    if (!fileName) {
        return '';
    }
    const dotIdx = fileName.lastIndexOf('.');
    if (dotIdx < 0 || dotIdx >= fileName.length - 1) {
        return '';
    }
    return fileName.substring(dotIdx + 1).toLowerCase();
}

class GroupCompanyRegisterDetailDialog extends Component {
    renderPreview = (attachmentUrl, attachmentName) => {
        const ext = getFileExtension(attachmentName);
        if (['png', 'jpg', 'jpeg', 'jpe', 'jfif', 'gif', 'bmp', 'webp'].includes(ext)) {
            return (
                <img
                    src={attachmentUrl}
                    alt='Attachment Not Found'
                    style={{ marginTop: 10, maxWidth: 1100 }}
                />
            );
        }

        return (
            <div style={{ marginTop: 10 }}>
                Preview not available. Please use the download link above.
            </div>
        );
    }

    render() {
        const { groupCompanyRegisterDownloadUrl } = this.props;
        const { isOpened, fields } = this.props.groupCompanyRegisterDetailDialog;
        const {
            companyCode,
            information,
            details,
            effectiveDate,
            endDate,
            attachment,
            attachmentOriginName,
            lastUpdatedBy,
            lastUpdateTime,
        } = fields;

        const attachmentName = attachmentOriginName || attachment;
        const attachmentUrl = attachment ? groupCompanyRegisterDownloadUrl + '/' + attachment : '';

        return (
            <div>
                <Modal
                    title='Group Company Register Detail'
                    centered
                    width={1200}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetGroupCompanyRegisterDetailDialog()}
                    footer={[
                        <Button key='Close' onClick={() => this.props.resetGroupCompanyRegisterDetailDialog()}>
                            Close
                        </Button>,
                    ]}
                >
                    <Row gutter={24} style={{ marginTop: 5 }}>
                        <Col span={6} align='right'><b>Company Code:</b></Col>
                        <Col span={6} align='left'>{companyCode}</Col>
                        <Col span={6} align='right'><b>Information:</b></Col>
                        <Col span={6} align='left'>{information}</Col>
                    </Row>
                    <Row gutter={24} style={{ marginTop: 5 }}>
                        <Col span={6} align='right'><b>Effective Date:</b></Col>
                        <Col span={6} align='left'>{effectiveDate}</Col>
                        <Col span={6} align='right'><b>End Date:</b></Col>
                        <Col span={6} align='left'>{endDate || 'Current'}</Col>
                    </Row>
                    <Row gutter={24} style={{ marginTop: 5 }}>
                        <Col span={6} align='right'><b>Attachment:</b></Col>
                        <Col span={18} align='left'>
                            {!!attachment && (
                                <a target='_blank' rel='noopener noreferrer' href={attachmentUrl}>
                                    {attachmentName}
                                </a>
                            )}
                        </Col>
                    </Row>
                    <Row gutter={24} style={{ marginTop: 5 }}>
                        <Col span={6} align='right'><b>Details:</b></Col>
                        <Col span={18} align='left'>{details}</Col>
                    </Row>
                    <Row gutter={24} style={{ marginTop: 5 }}>
                        <Col span={6} align='right'><b>Last Updated By:</b></Col>
                        <Col span={6} align='left'>{lastUpdatedBy}</Col>
                        <Col span={6} align='right'><b>Last Update Time:</b></Col>
                        <Col span={6} align='left'>{lastUpdateTime}</Col>
                    </Row>
                    {!!attachment &&
                        <Row gutter={24} style={{ marginTop: 5 }}>
                            <Col span={24} align='center'>
                                {this.renderPreview(attachmentUrl, attachmentName)}
                            </Col>
                        </Row>
                    }
                </Modal>
            </div>
        );
    }
}

export default GroupCompanyRegisterDetailDialog;
